var EvaluationItem = require("components/writing/evaluations/EvaluationItem");
var CurrentUser = require("lib/account/CurrentUser");

require("writing/evaluations/evaluation_box.scss");

class EvaluationBox extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var evaluation = props.response.evaluation;
		var editValue = !(evaluation && evaluation.score >= 0 && (evaluation.finalized || !this.isEditable(props)));

		this.state = {
			edit: editValue, highlightScore: null
		};
	}

	isEditable(props) {
		var props = props || this.props;
		return CurrentUser.isAdmin() && props.onChange != undefined;
	}

	handleChange(newScore) {
		if (this.state.edit) {
			if (this.props.onChange) {
				this.props.onChange(newScore);
			}

			this.setState({ edit: false });

		} else {
			this.setState({ edit: true });
		}
	}

	render() {
		var evaluationItem;
		var isVisible = CurrentUser.hasID(this.props.response.user_id) || CurrentUser.isAdmin();
		var evaluation = this.props.response.evaluation;

		if (!this.state.edit && isVisible && evaluation && evaluation.finalized) {
			// Show the grade if we are a student or a teacher not in edit mode
			evaluationItem = (
				<span className="evalOptions evaluationBox">
					<span className="evalSelected">
						<EvaluationItem score={ evaluation.score } handleChange={ this.handleChange } 
							clickable={ this.isEditable() } isSelected={ true }
							sharedNewsFeedItem={ this.props.sharedNewsFeedItem } />
					</span>
				</span>
			);

		} else if ( this.isEditable() ) {

			var items = [];
			for (var i = 1; i <= EvaluationBox.MAX_SCORE; i++) {
				if (evaluation) {
					var isSel = evaluation.score == i;
					var autoGraded = isSel && !evaluation.finalized;
				} else if (this.state.highlightScore) {
					var isSel = this.state.highlightScore == i;
				}
				items.push(
					<EvaluationItem score={ i } key={ i } isSelected={ isSel }
						clickable={ this.isEditable() }
						handleChange={ this.handleChange } autoGraded={ autoGraded } />
				);
			}
			evaluationItem = (
				<span className="evaluationBox" ref="container">
					<span className="evalSelection">
						{ items }
					</span>
				</span>
			);
		} else {
			evaluationItem = (<span></span>)
		}
		return evaluationItem;
	}
};

EvaluationBox.MAX_SCORE = 3;

EvaluationBox.propTypes = StrictPropTypes({
	response: PropTypes.object.isRequired,
	onChange: PropTypes.func
});

module.exports = EvaluationBox;



// WEBPACK FOOTER //
// ./modules/components/writing/evaluations/EvaluationBox.js